import { render, staticRenderFns } from "./FeedbackTypeItem.vue?vue&type=template&id=a7dbf328&scoped=true&"
import script from "./FeedbackTypeItem.vue?vue&type=script&lang=js&"
export * from "./FeedbackTypeItem.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackTypeItem.vue?vue&type=style&index=0&id=a7dbf328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dbf328",
  null
  
)

export default component.exports